export default function Loader(){

    return(
        <div className=" flex flex-col w-full h-full justify-center items-center absolute bg-white z-10">
            <img draggable="false" className=" h-20 z-10" src="./src/img/energopro.jpg" alt="Energo-Pro" />
            <img draggable="false" className=" h-40 -mt-14" src="./src/img/load.gif" alt="Energo-Pro" />
        </div>
    )
}